<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" label-width="90px" @submit.native.prevent>
            <el-form-item label="关键字：" prop="name">
                <el-input v-model.trim="searchForm.name" maxlength="20" placeholder="请输入分组名称(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('academic:grouping:grouping:add')" type="primary" size="small"
                           icon="el-icon-plus" @click="addData('view')">新增
                </el-button>
                <el-button v-if="hasPermission('academic:grouping:grouping:deleteColumn')" type="danger" size="small"
                           icon="el-icon-delete" @click="deleteColumn()">删除
                </el-button>
                <el-button v-if="hasPermission('academic:grouping:grouping:export')" type="danger" size="small"
                           @click="exportData()">
                    <i class="icon-piliangdaochu iconfont buIcon"/>
                    导出
                </el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                v-loading="loading"
                default-expand-all
                @select="selectFun"
                @select-all="selectAllFun"
                @selection-change="selectionChangeHandle"
                :row-class-name="getRowClassName"
                :header-row-class-name="getHeaderRowClassName"
                size="small" height="100%" :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                class="table" ref="multipleTable" row-key='id' border>
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column prop="groupingName" label="分组名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="groupingState" label="状态" show-overflow-tooltip>
                <template slot="header" slot-scope="scope">
                    <div>状态
                        <el-popover
                                placement="top-start"
                                width="200"
                                trigger="hover"
                                content="启用后，还需要在【分类索引管理】中添加并公开，才能应用于资源。">
                            <i slot="reference" class="el-icon-question"></i>
                        </el-popover>
                    </div>
                </template>
                <template slot-scope="{row}">
                    <el-switch
                            v-model="row.groupingState"
                            active-value="1"
                            @change="setType(row)"
                            inactive-value="0">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right" min-width="100px"
                    label="操作">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('academic:special:special:optResources')" type="text" size="small"
                               @click="optResources(scope.row)">关联资源
                    </el-button>
                    <el-button v-if="hasPermission('academic:grouping:grouping:edit')" type="text" size="small"
                               @click="addData('edit',scope.row)">修改
                    </el-button>
                    <el-button v-if="hasPermission('academic:grouping:grouping:deleteColumn')" type="text" size="small"
                               @click="deleteColumn(scope.row)">删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog class="el-dialogs el-dialogsDelete" title="提示" width="420px" :close-on-click-modal="false" :visible.sync="visible">
            <div class="el-dialogs-padding">
                <div>确认删除所选信息？</div>
                <div>该下级全部分组数据将同步删除</div>
<!--                <el-checkbox v-model="checked">该下级全部分组数据将同步删除</el-checkbox>-->
            </div>
            <div slot="footer">
                <el-button size="small" type="primary" @click="sureDele()" v-noMoreClick>确定</el-button>
                <el-button size="small" @click="visible = false">取消</el-button>
            </div>
        </el-dialog>
        <add-grouping ref="addGrouping" @refresh="refreshList()"></add-grouping>
        <opt-resources ref="optResources"></opt-resources>
    </div>
</template>

<script>
import AddGrouping from "@/views/modules/academic/grouping/addGrouping.vue";
import OptResources from "@/views/modules/academic/optResources.vue";
import XEUtils from "xe-utils";

export default {
    name: "grouping",
    components: {OptResources, AddGrouping},
    data() {
        return {
            searchForm: {
                name: '',
            },
            loading: false,
            dataList: [],
            dataListSelect: [],
            oneProductIsSelect:[],
            visible: false,
            checked: false,
            deltIds: [],
            originalData: [],

            searchFromData: {},
        }
    },

    mounted() {
        this.refreshList()
    },

    methods: {
        setNodeLevels(list, level = 1) {
            let that = this;
            list.forEach(function (node) {
                // 为当前节点设置层级属性
                node.level = level;
                // 遍历当前节点的子节点，并递归调用setNodeLevels函数
                if (node.children && node.children.length > 0) {
                    that.setNodeLevels(node.children, level + 1);
                }
            })
        },
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.searchFromData = this.searchForm
            this.$axios(this.api.academic.groupingList, {}).then(data => {
                if (data && data.status) {
                    this.originalData = data.data
                    this.dataList = this.handleTree(
                        data.data,
                        'id',
                        'parentId',
                        'children',
                        '0'
                    )
                    // 调用函数设置层级
                    this.setNodeLevels(this.dataList);
                    this.filterSearch();
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },
        filterSearch() {
            if (this.searchForm.name) {
                let options = {children: 'children'}
                let searchProps = ['groupingName']
                this.dataList = XEUtils.searchTree(this.dataList, item => searchProps.some(key => XEUtils.toValueString(item[key]).indexOf(this.searchForm.name) > -1), options)
            }
        },
        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //typeName view新增 edit修改
        addData(typeName, row) {
            if (typeName == 'view') {
                this.$axios(this.api.user.configKey + 'academic_grouping_hierarchy', {}).then(data => {
                    if (data && data.status) {
                        if (data.data) {
                            this.$refs.addGrouping.init(typeName, row, parseInt(data.data), JSON.parse(JSON.stringify(this.dataList)))
                        }
                    }
                })
            } else {
                this.$refs.addGrouping.init(typeName, row, null, this.dataList)
            }
        },

        //关联资源
        optResources(row){
            this.$refs.optResources.init(row,1)
        },

        //切换状态
        setType(row) {
            row.groupingState = row.groupingState == 1 ? 0 : 1
            this.$axios(this.api.academic.groupingUpdateById, {
                id: row.id,
                groupingState: row.groupingState == 1 ? 0 : 1,
            }, 'put').then(data => {
                if (data && data.status) {
                    this.$message.success('状态修改成功')
                    this.refreshList()
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //删除
        deleteColumn(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let statusTrueList = []
            this.deltIds = list.map(item => {
                if (item.groupingState == 1) {
                    statusTrueList.push(item)
                }
                return item.id
            })
            if (statusTrueList.length != 0) {
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.checked = false
            this.visible = true
        },

        //导出
        exportData() {
            if (this.dataList.length == 0) {
                this.$message.warning('暂无可导出的数据！')
                return
            }
            let ids = this.dataListSelect.map(item => {
                return item.id
            })
            this.exportExcel(this.api.academic.groupingExport, {
                ids,
                ...this.searchFromData,
            }, '分组信息', 'post')
        },

        //确定删除
        sureDele() {
            this.$axios(this.api.academic.groupingRemoveById, {
                ids: this.deltIds,
                checked: this.checked,
            }, 'delete').then(data => {
                if (data && data.status) {
                    this.$message.success('删除成功')
                    this.visible = false
                    this.refreshList('', 1)
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            console.log(val)
            this.dataListSelect = val
        },

        // 复选框点击事件
        selectFun (selection, row) {
            this.setRowIsSelect(row)
        },

        // 复选框点击事件
        setRowIsSelect (row) {
            // 为空字符串则对应行半选态，点击则应该变为全选，则为true
            if (row.isSelect === '') {
                this.$refs.multipleTable.toggleRowSelection(row, true)
            }
            row.isSelect = !row.isSelect
            const _this = this
            // 判断操作的是子级点复选框还是父级点复选框，如果是父级点，则控制子级点的全选和不全选

            // 1、只是父级 2、既是子集，又是父级 3、只是子级
            const levelStatus = getCurrentLevel(row)

            if (levelStatus === 1) {
                // 操作的是父级，则所有子集同步父级状态
                selectAllChildren(row.children)
            } else if (levelStatus === 2) {
                selectAllChildren(row.children)
                operateLastLevel(row)
            } else if (levelStatus === 3) {
                operateLastLevel(row)
            }
            // 判断当前操作行的层级状态
            function getCurrentLevel (row) {
                // 1、只是父级 2、既是子集，又是父级 3、只是子级
                if (row.parentId === undefined) {
                    return 1
                } else if (row.parentId && !(row.children && row.children.length)) {
                    return 3
                } else {
                    return 2
                }
            }

            // 递归处理children子级数据的isSelect状态以及对选框状态
            function selectAllChildren (children) {
                children && children.length && children.forEach((item) => {
                    item.isSelect = row.isSelect
                    _this.toggleRowSelection(item, row.isSelect)
                    if (item.children && item.children.length) {
                        selectAllChildren(item.children)
                    }
                })
            }
            // 子级向上操作父级状态
            function operateLastLevel (row) {
                // 操作的是子节点,则
                // 1、获取父节点
                // 2、判断子节点选中个数，如果全部选中则父节点设为选中状态，如果都不选中，则为不选中状态，如果部分选择，则设为不明确状态
                const item = getExplicitNode(_this.tableData, row.parentId)
                if (!item){
                    return
                }
                const selectStatusArr = getSelectStatus([], item.children)

                // 判断所有子集选中态，都为true则父级也选中，都为false则不选中，否则为半选
                const allSelected = selectStatusArr.every(selectItem => selectItem === true)
                const allUnselected = selectStatusArr.every(selectItem => selectItem === false)
                if (allSelected) {
                    item.isSelect = true
                    _this.toggleRowSelection(item, true)
                } else if (allUnselected) {
                    item.isSelect = false
                    _this.toggleRowSelection(item, false)
                } else {
                    item.isSelect = ''
                }
                // 如果当前节点的parentId存在，则还有父级，继续递归往上一层操作
                if (item.parentId !== undefined) {
                    operateLastLevel(item)
                }
            }
            // 递归获取所有子级的选中状态数组
            function getSelectStatus (selectStatusArr, children) {
                if (!children || !children.length) {
                    return selectStatusArr
                }
                children.forEach((child) => {
                    selectStatusArr.push(child.isSelect)
                    if (child.children && child.children.length) {
                        getSelectStatus(selectStatusArr, child.children)
                    }
                })
                return selectStatusArr
            }

            // 获取明确父级的节点
            function getExplicitNode (tableData, parentId) {
                let result = null
                function findNode (data) {
                    if (!data || data.length == 0) return
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].id === parentId) {
                            result = data[i]
                            break
                        }
                        if (data[i].children && data[i].children.length) {
                            findNode(data[i].children)
                        }
                    }
                }
                findNode(tableData)
                return result
            }
        },

        // 表格全选事件
        selectAllFun (selection) {
            const firstLevelStatus = this.dataList.map(item => item.isSelect)
            // 判断一级是否是全选.如果一级产品全为true，则设置为取消全选，否则全选
            const isAllSelect = firstLevelStatus.every(status => status)
            // 设置所以一级和二级为选中状态
            this.dataList.forEach((item) => {
                item.isSelect = isAllSelect
                this.toggleRowSelection(item, !isAllSelect)
                this.selectFun(selection, item)
            })
        },
        // 设置当前行的选中态
        toggleRowSelection (row, flag) {
            if (row) {
                this.$nextTick(() => {
                    this.$refs.multipleTable &&
                    this.$refs.multipleTable.toggleRowSelection(row, flag)
                })
            }
        },
        // 表格行样式 当当前行的状态为不明确状态时，添加样式，使其复选框为不明确状态样式
        getRowClassName ({ row }) {
            if (row.isSelect === '') {
                return 'indeterminate'
            }
        },
        // 表格标题样式 当一级目录有为不明确状态时，添加样式，使其全选复选框为不明确状态样式
        getHeaderRowClassName ({ row }) {
            const isIndeterminate = this.dataList.some(item => item.isSelect === '')
            if (isIndeterminate) {
                return 'indeterminate'
            }
            return ''
        },
    }
}
</script>

<style lang="scss" scoped>
.el-dialogsDelete{
    .el-dialogs::v-deep .el-dialog__body {
        height: auto !important;
    }

    .el-dialogs-padding {
        padding: 10px 0 20px 10px;

        div {
            margin-bottom: 5px;
        }
    }
}

.indeterminate .el-checkbox__input .el-checkbox__inner {
    background-color: #409eff !important;
    border-color: #409eff !important;
    color: #fff !important;
}

.indeterminate .el-checkbox__input.is-checked .el-checkbox__inner::after {
    transform: scale(0.5);
}

.indeterminate .el-checkbox__input .el-checkbox__inner {
    background-color: #f2f6fc;
    border-color: #dcdfe6;
}

.indeterminate .el-checkbox__input .el-checkbox__inner::after {
    border-color: #c0c4cc !important;
    background-color: #c0c4cc;
}

.indeterminate .el-checkbox__input .el-checkbox__inner::after {
    content: '';
    position: absolute;
    display: block;
    background-color: #fff;
    height: 2px;
    transform: scale(0.5);
    left: 0;
    right: 0;
    top: 5px;
    width: auto !important;
}
</style>
